//
// Copyright (c) 2011-2020 by Curalate, Inc.
//
import { O } from 'ts-toolbelt';

type MappedObject<T extends Record<string, any>, U> = {
  [idx in keyof T]: U;
};

/**
 * Map over the values of an object, returning a new object.
 *
 * @param object An object to map over
 * @param transform Transform function to apply to each value. Arguments are (value, key, object)
 * @returns A new object with all the keys from the original object, and values returned by the transform method.
 */
export function mapObject<T extends Record<string, any>, U>(
  object: T,
  transform: (value: O.UnionOf<T>, key: keyof T, context: T) => U,
): MappedObject<T, U> {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [
      key,
      transform(value, key, object),
    ]),
  ) as MappedObject<T, U>;
}
